import { render, staticRenderFns } from "./CarriersTab.vue?vue&type=template&id=0cfd8a36&"
import script from "./CarriersTab.vue?vue&type=script&lang=js&"
export * from "./CarriersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports